import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import {
  ICallPersonalizedPermissions,
  PermissionsTypes,
} from '@gem/call/Model/callPermissions/callPermissionsModel.types';
import {
  PERMISSIONS_CUSTOM_TRANSLATIONS,
  PERMISSIONS_TYPES_TRANSLATIONS,
} from '@gem/call/constants';
import { CallChangeMemberPermissionPopup } from '@gem/call/popups/Permissions/CallChangeMemberPermissionPopup/CallChangeMemberPermissionPopup';
import { PopupStore, popupsTasks } from '@gem/popups';

import { ICallMemberPermissionProps } from './CallMemberPermission.types';

interface ICallMemberPermissionPresenter {
  childPopup: PopupStore | null;
  permissions: ICallPersonalizedPermissions | null;
  permissionLabel: string;
  permissionValue: string | null;
  memberPermissionsId?: string;
  permissionType: PermissionsTypes;
  onClick(): void;
}

export const useCallMemberPermissionPresenter = (
  props: ICallMemberPermissionProps
): ICallMemberPermissionPresenter => {
  const presenter = useLocalObservable<ICallMemberPermissionPresenter>(() => ({
    childPopup: null,
    memberPermissionsId: props.memberPermissionsId,
    permissionType: props.permissionType,

    get permissions(): ICallPersonalizedPermissions | null {
      const callPermissions = props.call.permissions;

      if (!callPermissions) {
        return null;
      }

      const personalizedPermissions = presenter.memberPermissionsId
        ? callPermissions.editedPermissions.permissions
        : callPermissions.personalizedPermissions;

      return callPermissions.getMemberPersonalizedPermissions(personalizedPermissions);
    },

    get permissionLabel(): string {
      return PERMISSIONS_TYPES_TRANSLATIONS[presenter.permissionType];
    },

    get permissionValue(): string | null {
      if (!presenter.permissions) {
        return null;
      }

      const permissionsValue = presenter.permissions[presenter.permissionType];

      if (!permissionsValue) {
        return null;
      }

      return PERMISSIONS_CUSTOM_TRANSLATIONS[permissionsValue];
    },

    onClick(): void {
      if (!presenter.permissionValue || !presenter.memberPermissionsId) {
        return;
      }

      props.popupInstance.hide();
      presenter.childPopup = popupsTasks.openPopup(CallChangeMemberPermissionPopup, {
        onClose: () => props.onClose(),
        onBack: () => props.popupInstance.show(),
        params: {
          permissionType: presenter.permissionType,
          memberPermissionsId: presenter.memberPermissionsId,
          callController: props.callController,
          call: props.call,
        },
      });
    },
  }));

  useEffect(() => {
    presenter.permissionType = props.permissionType;
    presenter.memberPermissionsId = props.memberPermissionsId;
  }, [props.permissionType, props.memberPermissionsId]);
  return presenter;
};
